<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-tachometer"></i> Vaccination Camp Tracker Dashboard</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->

       <!--Vaccination Camp Tracker (Region Wise)  -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                   <i class="fa fa-link"></i> Vaccination Camp Tracker (Region Wise)
                </div>
                <div class="col-12 col-pn">
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                            <tr class="bg-i-light">
                               <th rowspan="2">Region</th>
                               <th rowspan="2">Employee Count</th>
                               <th colspan="6">All employees Completion Count</th>
                            </tr>
                            <tr>
                            
                               <th class="bg-success1">No of Non Vaccinated Emps with Zero Request by Site</th>
                               <th class="bg-success1">No of Emps Camp Request By Site</th>
                               <th class="bg-warning1">No of Emps Request Approved</th>
                               <th class="bg-danger1">No of Emps in-Process Request</th>
                               <th class="bg-info1">Count of Request Pending with Admin beyond 3 days</th>
                                <th class="bg-info1">Count of Request reopen with Site Manager beyond 3 days</th>
                            </tr>
                         </thead>
                         <tr>
                             <td colspan="8" class="text-danger" style="text-align: left !important;">
                                Top 3	Regions	
                             </td>
                         </tr>
                         <tbody>
                            <tr>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                            </tr>
                         </tbody>
                         <tr>
                            <td colspan="8" class="text-danger" style="text-align: left !important;">
                               Buttom	Regions	
                            </td>
                        </tr>
                        <tbody>
                           <tr>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                           </tr>
                        </tbody>
                      </table>
                   </div>
                </div>
             </div>

<!--Vaccination Camp Tracker (Segment Wise) -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                <i class="fa fa-link"></i> Vaccination Camp Tracker (Segment Wise)
                </div>
                <div class="col-12 col-pn">
                <div class="table-responsive">
                    <table class="table table-align">
                        <thead>
                           <tr class="bg-i-light">
                              <th rowspan="2">Segments</th>
                              <th rowspan="2">Employee Count</th>
                              <th colspan="6">All employees Completion Count</th>
                           </tr>
                           <tr>
                           
                              <th class="bg-success1">No of Non Vaccinated Emps with Zero Request by Site</th>
                              <th class="bg-success1">No of Emps Camp Request By Site</th>
                              <th class="bg-warning1">No of Emps Request Approved</th>
                              <th class="bg-danger1">No of Emps in-Process Request</th>
                              <th class="bg-info1">Count of Request Pending with Admin beyond 3 days</th>
                               <th class="bg-info1">Count of Request reopen with Site Manager beyond 3 days</th>
                           </tr>
                        </thead>
                        <tr>
                            <td colspan="8" class="text-danger" style="text-align: left !important;">
                               Top 3	Segments	
                            </td>
                        </tr>
                        <tbody>
                           <tr>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                           </tr>
                        </tbody>
                        <tr>
                           <td colspan="8" class="text-danger" style="text-align: left !important;">
                              Buttom	Segments	
                           </td>
                       </tr>
                       <tbody>
                          <tr>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                          </tr>
                       </tbody>
                     </table>
                </div>
                </div>
            </div>
            
<!-- Base Employee Vaccination Camp Tracker (Segment Wise) -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                <i class="fa fa-link"></i> Base Employee Vaccination Camp Tracker (Segment Wise)
                </div>
                <div class="col-12 col-pn">
                <div class="table-responsive">
                    <table class="table table-align">
                        <thead>
                           <tr class="bg-i-light">
                              <th rowspan="2">Segments</th>
                              <th rowspan="2">Employee Count</th>
                              <th colspan="6">All employees Completion Count</th>
                           </tr>
                           <tr>
                           
                              <th class="bg-success1">No of Non Vaccinated Emps with Zero Request by Site</th>
                              <th class="bg-success1">No of Emps Camp Request By Site</th>
                              <th class="bg-warning1">No of Emps Request Approved</th>
                              <th class="bg-danger1">No of Emps in-Process Request</th>
                              <th class="bg-info1">Count of Request Pending with Admin beyond 3 days</th>
                               <th class="bg-info1">Count of Request reopen with Site Manager beyond 3 days</th>
                           </tr>
                        </thead>
                        <tr>
                            <td colspan="8" class="text-danger" style="text-align: left !important;">
                               Top 3	Segments	
                            </td>
                        </tr>
                        <tbody>
                           <tr>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                              <td>0</td>
                           </tr>
                        </tbody>
                        <tr>
                           <td colspan="8" class="text-danger" style="text-align: left !important;">
                              Buttom	Segments	
                           </td>
                       </tr>
                       <tbody>
                          <tr>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                             <td>0</td>
                          </tr>
                       </tbody>
                     </table>
                </div>
                </div>
            </div>

            
             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

